import A from 'const/actionTypes'

const compareMobilePowerRankings = (a, b) => {
  let sortOrder = 0

  if (a.mmr < b.mmr) {
    sortOrder = -1
  } else if (a.mmr > b.mmr) {
    sortOrder = 1
  }

  return sortOrder
}

export default (currentState, action) => {
  let updatedState = Object.assign({}, currentState)

  switch (action.type) {
    case A.CLEAR_MOBILE_POWER_RANKINGS:
      updatedState = {}
      break
    case A.DELETE_MOBILE_POWER_RANKING:
      updatedState[action.gamerId] = null
      break
    case A.SET_MOBILE_POWER_RANKINGS:
      const updatedMobilePowerRankings = {}
      const newMobilePowerRankings = action.mobilePowerRankings

      const sortedMobilePowerRankings = Object.keys(newMobilePowerRankings).map(newMobilePowerRankingId => {
        const newMobilePowerRanking = newMobilePowerRankings[newMobilePowerRankingId]
        newMobilePowerRanking.tempId = newMobilePowerRankingId
        return newMobilePowerRanking
      }).sort(compareMobilePowerRankings)

      sortedMobilePowerRankings.map(sortedMobilePowerRanking => {
        const mobilePowerRankingId = sortedMobilePowerRanking.tempId
        delete sortedMobilePowerRanking.tempId

        updatedMobilePowerRankings[mobilePowerRankingId] = sortedMobilePowerRanking
      })

      updatedState = updatedMobilePowerRankings
      break
  }

  return updatedState
}



// WEBPACK FOOTER //
// ./src/app/reducers/mobilePowerRankings.js